import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function useCategoryQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const categoryBusinessQuery = useQuery({
        queryFn: () =>
            axiosPrivate
                .get("category/get_for_business/")
                .then(r => r.data),
        queryKey: ["category", "get_for_business"],
    });

    const useCategoryDetailQuery = (id) =>
        useQuery({
            queryKey: ["category", id],
            queryFn: ({ queryKey }) => {
                const [, categoryId] = queryKey;
                return axiosPrivate
                    .get(`category/${categoryId}/`)
                    .then((r) => r.data);
            },
            enabled: !!id, // prevents running until id exists
        });

    // MUTATIONS ------------------------------------------------------

    const createCategoryMutation = useMutation({
            mutationFn: (data) => axiosPrivate.post(`category/`, data, {headers: {"Content-Type": "multipart/form-data"}}).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["category"]);
            },
        });

    const updateCategoryMutation = useMutation({
            mutationFn: ({id, data}) => axiosPrivate.patch(`category/${id}/`, data, {headers: {"Content-Type": "multipart/form-data"}}).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["category"]);
            },
        });

    const deleteCategoryMutation = useMutation({
            mutationFn: id => axiosPrivate.delete(`category/${id}/`).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["category"]);
            },
        });



    return {
        categoryBusinessQuery,
        useCategoryDetailQuery,
        createCategoryMutation,
        updateCategoryMutation,
        deleteCategoryMutation
    };
}
